import { createContext } from "react";
import { IConfig } from "./types";

export const ConfigContext = createContext<IConfig>({} as IConfig);
